import { OverlayOwnerContext } from "@/components/modal/overlay-context";
import React, { useContext } from "react";
import { create as createPromiseModal, type CreateInstance } from "react-modal-promise";

export * from "react-modal-promise";
export { default } from "react-modal-promise";

function createWithOwner(ownerId: string | null): CreateInstance {
  return (Component, options) => (props) => {
    const OwnedModal: typeof Component = (instanceProps) => (
      <OverlayOwnerContext.Provider value={ownerId}>
        <Component {...instanceProps} />
      </OverlayOwnerContext.Provider>
    );
    return createPromiseModal(OwnedModal, options)(props);
  };
}

// Promise dialogs mount under ModalContainer, so capture the opener's ownership at invocation.
export const create: CreateInstance = (Component, options) => (props) => {
  const ownerId =
    typeof document === "undefined"
      ? null
      : document.activeElement?.closest("[data-overlay-id]")?.getAttribute("data-overlay-id") ??
        null;
  return createWithOwner(ownerId)(Component, options)(props);
};

/** Use for delayed/programmatic opens that must retain their React owner after focus moves. */
export function useCreateModal(): CreateInstance {
  const ownerId = useContext(OverlayOwnerContext);
  return createWithOwner(ownerId);
}
